import { render, staticRenderFns } from "./experimentDetail.vue?vue&type=template&id=0197b47e&scoped=true"
import script from "./experimentDetail.vue?vue&type=script&lang=js"
export * from "./experimentDetail.vue?vue&type=script&lang=js"
import style0 from "./experimentDetail.vue?vue&type=style&index=0&id=0197b47e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0197b47e",
  null
  
)

export default component.exports